<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="d-flex gap-2 w-100">
    <div>
      <template v-if="isHuman">
        <template v-if="photoURL">
          <img
            :src="photoURL"
            alt="Icon"
            :style="{ width: '32px', height: '32px', borderRadius: '9999px' }"
          />
        </template>
        <template v-else>
          <div
            :style="{
              width: '32px',
              height: '32px',
              borderRadius: '9999px',
              backgroundColor: '#4c2fa2',
            }"
          >
            {{ userDisplayName?.substring(0, 1).toUpperCase() }}
          </div>
        </template>
      </template>
      <template v-else>
        <div class="position-relative d-flex align-items-center">
          <img
            src="@/assets/hope/hope-with-background.png"
            alt="AI Logo"
            :style="{
              width: '32px',
              height: '32px',
              borderRadius: '9999px',
            }"
          />
          <div
            class="ai-badge"
            :style="{
              position: 'absolute',
              top: '60%',
              left: '-5%',
              backgroundColor: '#f9ecff',
              borderRadius: '50%',
              border: '0.5px solid #fff',
              padding: '2px',
              zIndex: '999',
            }"
          >
            <div class="fw-bold" :style="{ fontSize: '5px', color: '#8c15dc' }">
              <div
                :style="{
                  lineHeight: '7px',
                  borderRadius: '2px',
                  border: '1px solid #8c15dc',
                  padding: '0px 0.6px 0px 0.6px',
                }"
              >
                AI
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="d-flex flex-column">
      <div
        class="fw-light"
        :style="{
          fontSize: '14px',
          whiteSpace: 'pre-wrap',
        }"
      >
        <!-- Security: Using v-html is safe here as message is processed through processMarkdown -->
        <span v-html="processedMessage" />
      </div>
      <div
        v-if="sources && sources.length"
        class="chat-row-sources d-flex flex-wrap gap-1"
      >
        <!-- New tab so following a source never unmounts the page the member is working on. -->
        <router-link
          v-for="source in sources"
          :key="source.slug"
          :to="{ name: 'HelpCenterDoc', params: { slug: source.slug } }"
          target="_blank"
          rel="noopener noreferrer"
          class="chat-row-source-chip"
        >
          {{ source.title }}
        </router-link>
      </div>
      <div class="fw-semibold" :style="{ fontSize: '10px', color: '#858585' }">
        {{ isHuman ? "You" : agentName }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { processMarkdown } from "@/utils/markdown";

const props = defineProps<{
  message: string;
  isHuman: boolean;
  agentName: string;
  photoURL?: string;
  userDisplayName?: string;
  sources?: { slug: string; title: string }[];
}>();

const processedMessage = computed(() => processMarkdown(props.message));
</script>

<style scoped lang="scss">
@use "@/assets/styles/design-tokens" as *;

.d-flex {
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.flex-wrap {
  flex-wrap: wrap;
}

.align-items-center {
  align-items: center;
}

.gap-1 {
  gap: $spacing-1;
}

.gap-2 {
  gap: $spacing-2;
}

.w-100 {
  width: 100%;
}

.chat-row-sources {
  margin-top: $spacing-1;
}

.chat-row-source-chip {
  display: inline-flex;
  align-items: center;
  padding: $spacing-1 $spacing-2;
  border-radius: $radius-full;
  border: 1px solid $color-border-subtle;
  background-color: $color-surface-secondary;
  color: $color-content-primary;
  text-decoration: none;
  @include txt-xsmall;

  &:hover {
    background-color: $color-neutral-50;
  }
}

.position-relative {
  position: relative;
}

.fw-light {
  font-weight: 300;
}

.fw-semibold {
  font-weight: 600;
}

.fw-bold {
  font-weight: 700;
}
</style>
